// extracted by mini-css-extract-plugin
module.exports = {"mainstddiv":"stddetails_mainstddiv__3Xpoz","infodiv":"stddetails_infodiv__2FBHP","wit":"stddetails_wit__2eUE6","maindivstddetails":"stddetails_maindivstddetails__1nK27"};